<template>
    <div class="public-index">
        <el-divider content-position="left">公众号推广统计</el-divider>
        <el-card shadow="always">
            <div slot="header">
                <span>统计数据</span>
            </div>
            <el-tabs v-model="miniProTab" @tab-click="handleClick" type="border-card">
                <el-tab-pane label="企业火公众号" name="qyh"></el-tab-pane>
                <el-tab-pane label="账六六公众号" name="z66"></el-tab-pane>

                <el-row>
                    <el-button size="small" round :class="{ 'el-button--primary': isPrimary['today'] === true }"
                        @click.native="handleChoose('today')">今日</el-button>
                    <el-button size="small" round :class="{ 'el-button--primary': isPrimary['yesterday'] === true }"
                        @click.native="handleChoose('yesterday')">昨日</el-button>
                    <div style="text-align: center;display: inline-block;margin-left: 0.2rem;">
                        <el-date-picker size="medium" v-model="tabDate" type="datetimerange" align="right" unlink-panels
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                            :picker-options="ysyTypeInPickerOptions" value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']" @change="handleSearch">
                        </el-date-picker>
                    </div>
                </el-row>


                <!-- <tab-div :tabArr="getTabArr()" @choosed="getDateChoosed"></tab-div> -->

                <!-- <el-tab-pane label="云上公司注册抖音小程序" name="ccrmp_bd"></el-tab-pane> -->
                <!-- <el-tabs v-model="fromTab" @tab-click="handleClickfromTab">
                    <el-tab-pane label="今日" name="today"></el-tab-pane>
                    <el-tab-pane label="昨日" name="yesterday"></el-tab-pane>
                    dddd
                </el-tabs> -->
                <!-- <div
                    style="display: flex;justify-content:space-evenly;font-size: medium;margin-top: 0.2rem;font-weight: bold;">
                    <div>
                        <span class="title">今日新增注册用户数</span>:
                        <span>
                            <el-link @click="openUserDrawer('今日新增注册用户', 'today')" class="font-s-m">{{ todayData.reger }}
                            </el-link>
                        </span>
                    </div>
                    <div>
                        <span class="title">今日下单(未支付)数量</span>:
                        <span><el-link @click="openOrderDrawer('今日下单(未支付)', 'today')" class="font-s-m">{{
                            todayData.order_unPay }}
                            </el-link></span>
                    </div>
                    <div>
                        <span class="title">今日支付成功数量</span>:
                        <span><el-link @click="openOrderDrawer('今日支付成功', 'today_s')" class="font-s-m">{{ todayData.order }}
                            </el-link></span>
                    </div>
                </div> -->
                <!-- <div
                    style="display: flex;justify-content:space-evenly;font-size: medium;margin-top: 0.2rem;font-weight: bold;">
                    <div>
                        <span class="title">昨日新增注册用户数</span>:
                        <span><el-link @click="openUserDrawer('昨日新增注册用户', 'yesterday')" class="font-s-m">{{
                            yesterdayData.reger }}
                            </el-link></span>
                    </div>
                    <div>
                        <span class="title">昨日下单(未支付)数量</span>:
                        <span><el-link @click="openOrderDrawer('昨日下单(未支付)', 'yesterday')" class="font-s-m">{{
                            yesterdayData.order_unPay }}
                            </el-link></span>
                    </div>
                    <div>
                        <span class="title">昨日支付成功数量</span>:
                        <span><el-link @click="openOrderDrawer('昨日支付成功', 'yesterday_s')" class="font-s-m">{{
                            yesterdayData.order }}
                            </el-link></span>
                    </div>
                </div>
                <div
                    style="display: flex;justify-content:space-evenly;font-size: medium;margin-top: 0.2rem;font-weight: bold;">
                    <div>
                        <span class="title_total">新增注册用户总数</span>:
                        <span>
                            <el-link @click="openUserDrawer('新增注册用户总数', 'total')" class="font-s-m">{{ totalData.reger }}
                            </el-link>
                        </span>
                    </div>
                    <div>
                        <span class="title_total">下单(未支付)总数量</span>:
                        <span><el-link @click="openOrderDrawer('下单(未支付)总数量', 'total')" class="font-s-m">{{
                            totalData.order_unPay }}
                            </el-link></span>
                    </div>
                    <div>
                        <span class="title_total">支付成功总数量</span>:
                        <span><el-link @click="openOrderDrawer('支付成功总数量', 'total_s')" class="font-s-m">{{
                            totalData.order
                        }}
                            </el-link></span>
                    </div>
                </div>
                <hr style="margin-bottom: 0.2rem;margin-top: 0.2rem;">
                <div style="text-align: center;">
                    <el-date-picker size="medium" v-model="date" type="datetimerange" align="right" unlink-panels
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        :picker-options="ysyTypeInPickerOptions" value-format="yyyy-MM-dd HH:mm:ss"
                        :default-time="['00:00:00', '23:59:59']" @change="handleSearch">
                    </el-date-picker>
                </div>
                <div
                    style="display: flex;justify-content:space-evenly;font-size: medium;margin-top: 0.5rem;font-weight: bold;">
                    <div>
                        <span class="title">新增注册用户数</span>:
                        <span><el-link @click="openUserDrawer('新增注册用户', 'location')" class="font-s-m">{{ locationData.reger
                        }}
                            </el-link></span>
                    </div>
                    <div>
                        <span class="title">下单(未支付)数量</span>:
                        <span><el-link @click="openOrderDrawer('下单(未支付)', 'location')" class="font-s-m">{{
                            locationData.order_unPay }}
                            </el-link></span>
                    </div>
                    <div>
                        <span class="title">支付成功数量</span>:
                        <span><el-link @click="openOrderDrawer('支付成功', 'location_s')" class="font-s-m">{{ locationData.order
                        }}
                            </el-link></span>
                    </div>
                </div> -->
                <!-- <hr style="margin-bottom: 0.2rem;margin-top: 0.2rem;"> -->
                <!-- <el-card shadow="always"> -->
                <!-- <div slot="header">
                        <span style="color: #67C23A;">字段统计</span>
                    </div> -->
                <div style="margin-top: 0.2rem;">
                    <table class="field-table" border>
                        <tr>
                            <td class="mini-pro-type public" colspan="2">公众号用户需求</td>
                        </tr>
                        <tr>
                            <td class="centered">字段</td>
                            <td class="centered">数据统计</td>
                        </tr>
                        <tr v-for="item, key, index in publicData['needs'] " :key=index>
                            <td>{{ key }}</td>
                            <td class="centered-count"><el-link @click="openUserDemandsDrawer('public', key)" type="danger">{{
                item }}</el-link></td>
                        </tr>
                    </table>
                </div>


                <el-tabs v-model="fieldTabDate" @tab-click="handleClickFieldDateTab">
                    <el-tab-pane label="注册" name="1"></el-tab-pane>
                    <el-tab-pane label="下单支付成功" name="2"></el-tab-pane>
                    <el-tab-pane label="下单未支付" name="3"></el-tab-pane>

                    <div>
                        <table class="field-table" border>
                            <tr>
                                <td class="mini-pro-type ccrmp" colspan="2">云上公司注册微信小程序</td>
                            </tr>
                            <tr>
                                <td class="centered">字段</td>
                                <td class="centered">数据统计</td>
                            </tr>
                            <tr v-for="item, key, index in publicData['ccrmp_wc'] " :key=index>
                                <td>{{ key }}</td>
                                <td class="centered-count"><el-link @click="openDrawer('ccrmp_wc', key)"
                                        type="danger">{{ item }}</el-link></td>
                            </tr>
                        </table>

                        <table class="field-table" border style="margin-top: 0.6rem;">
                            <tr>
                                <td class="mini-pro-type qyh" colspan="2">企业火小程序</td>
                            </tr>
                            <tr>
                                <td class="centered">字段</td>
                                <td class="centered">数据统计</td>
                            </tr>
                            <tr v-for="item, key, index in publicData['qyh'] " :key=index>
                                <td>{{ key }}</td>
                                <td class="centered-count"><el-link @click="openDrawer('qyh', key)" type="danger">{{
                item }}</el-link></td>
                            </tr>
                        </table>
                    </div>


                </el-tabs>
            </el-tabs>
        </el-card>
        <el-drawer title="" :visible.sync="userDrawer" direction="rtl" :before-close="handleCloseUserDrawer" size="70%">
            <template slot="title">
                <span style="color: #409eff; font-size: 0.3rem">{{ user_title }}</span>
            </template>
            <user-com :dataType="dataType" />
        </el-drawer>
        <el-drawer title="" :visible.sync="orderDrawer" direction="rtl" :before-close="handleCloseOrderDrawer"
            size="70%">
            <template slot="title">
                <span style="color: #409eff; font-size: 0.3rem">{{ order_title }}</span>
            </template>
            <order-com :dataTypeOrder="dataTypeOrder" />
        </el-drawer>
        <el-drawer title="" :visible.sync="userDemandsDrawer" direction="rtl" :before-close="handleCloseUserDemandsDrawer" size="70%">
            <template slot="title">
                <span style="color: #409eff; font-size: 0.3rem">公众号用户需求</span>
            </template>
            <user-demands-compoent :dataType="dataTypeUserDemands" />
        </el-drawer>
    </div>
</template>

<script>
import { fscDate } from '../../../../static/mixins/fastChooseDate'
import UserCom from './Components/UserCompoent'
import OrderCom from './Components/OrderCompoent'
import UserDemandsCompoent from './Components/UserDemandsCompoent';
import TabDiv from '../../../commonReform/TabDiv.vue';
export default {
    name: 'Index',
    mixins: [fscDate],
    components: { UserCom, OrderCom, TabDiv, UserDemandsCompoent },
    data() {
        return {
            hyperfHost:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501"
                    : "https://qyh-next-server.zhang66.cn",
            miniProTab: 'qyh',
            fromTab: 'today',
            fieldTabDate: '1',
            fieldTypeTab: '1',
            needType: null,
            needFrom: null,
            needFieldType: null,
            needFieldDate: null,
            fieldData: {
                reg: {},
                order: {}
            },
            fieldDataNew: {},
            todayData: {
                reger: null,
                order_unPay: null,
                order: null
            },
            totalData: {
                reger: null,
                order_unPay: null,
                order: null
            },
            yesterdayData: {
                reger: null,
                order_unPay: null,
                order: null
            },
            locationData: {
                reger: null,
                order_unPay: null,
                order: null
            },
            date: '',
            userDrawer: false,
            user_title: null,
            dataType: {},
            orderDrawer: false,
            order_title: null,
            userDemandsDrawer: false,
            isPrimary: [],
            dataTypeOrder: {},
            dataTypeUserDemands: {},
            tabData: {
                name: 'today'
            },
            tabDate: '',
            publicData: [],
        }
    },
    methods: {
        handleChoose(key) {
            this.isPrimary = []
            this.isPrimary.push(key)
            this.isPrimary[key] = true
            this.tabDate = ''
            this.tabData = { name: key }
        },
        handleSearch(val) {
            if (val) {
                this.isPrimary = []
                this.tabData = { date: val }
            } else {
                this.clearData()
            }
        },
        clearData() {
            this.publicData = this.$options.data().publicData
        },
        loadData() {
            this.clearData()
            this.$axios.get(`${this.hyperfHost}/v1/api/promotion/public/get_data`, {
                params: {
                    miniProTab: this.miniProTab ? this.miniProTab : 'qyh_public',
                    // from: this.needFrom ? this.needFrom : 4,
                    date_type: this.tabData,
                    order_type: this.fieldTabDate ? this.fieldTabDate : '1',

                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    // this.fieldData = data.data
                    this.publicData = data.data.data
                }
            }).catch()
        },
        getDateChoosed(val) {
            this.tabData = val
        },
        getTabArr() {
            return [
                {
                    name: '今日',
                    selected: true,
                    round: true,
                    size: 'small',
                },
                {
                    name: '昨日',
                    size: 'small',
                    round: true,
                },
            ];
        },
        loadField() {
            this.fieldData = this.$options.data().fieldData
            this.$axios.get(`${this.hyperfHost}/v1/api/promotion/get_field`, {
                params: {
                    type: this.needType ? this.needType : 'ccrmp_wc',
                    from: this.needFrom ? this.needFrom : 4,
                    date_type: this.needFieldDate ? this.needFieldDate : '1',
                    field_type: this.needFieldType ? this.needFieldType : '1',
                    date: this.date
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    // this.fieldData = data.data
                    this.fieldDataNew = data.data
                }
            }).catch()
        },
        loadTotal() {
            this.todayData = this.$options.data().totalData
            this.$axios.get(`${this.hyperfHost}/v1/api/promotion/get_total`, {
                params: {
                    type: this.needType ? this.needType : 'ccrmp_wc',
                    from: this.needFrom ? this.needFrom : 4,
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.totalData.reger = data.data.reger
                    this.totalData.order_unPay = data.data.order_unPay
                    this.totalData.order = data.data.order
                }
            }).catch()
        },
        handleClick(val) {
            this.needType = val.name
        },
        getData() {
            this.todayData = this.$options.data().todayData
            this.$axios.get('api/api3_ccrmp_get_promotion_statistics', {
                params: {
                    type: this.needType ? this.needType : 'ccrmp_wc',
                    from: this.needFrom ? this.needFrom : 4,
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.todayData.reger = data.data.reger
                    this.todayData.order_unPay = data.data.order_unPay
                    this.todayData.order = data.data.order
                }
            }).catch()
        },
        getDataYesterday() {
            this.yesterdayData = this.$options.data().yesterdayData
            this.$axios.get('api/api3_ccrmp_get_promotion_statistics_yesterday', {
                params: {
                    type: this.needType ? this.needType : 'ccrmp_wc',
                    from: this.needFrom ? this.needFrom : 4,

                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.yesterdayData.reger = data.data.reger
                    this.yesterdayData.order_unPay = data.data.order_unPay
                    this.yesterdayData.order = data.data.order
                }
            }).catch()
        },
        handleClickfromTab(val) {
            this.needFrom = val.name
        },
        handleClickFieldDateTab(val) {
            this.date = ''
            this.locationData = this.$options.data().locationData
            this.needFieldDate = val.name
        },
        handleClickFieldTypeTab(val) {
            this.needFieldType = val.name
        },
        // handleSearch(val) {
        //     if (val) {
        //         this.locationDate()
        //         this.loadField()
        //     } else {
        //         this.locationData = this.$options.data().locationData
        //     }
        // },
        locationDate() {
            this.locationData = this.$options.data().locationData
            if (!this.date) return false
            this.$axios.get('api/api3_ccrmp_get_promotion_statistics_location_date', {
                params: {
                    type: this.needType ? this.needType : 'ccrmp_wc',
                    from: this.needFrom ? this.needFrom : 4,
                    date: this.date
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.locationData.reger = data.data.reger
                    this.locationData.order_unPay = data.data.order_unPay
                    this.locationData.order = data.data.order
                }
            }).catch()
        },
        handleCloseUserDrawer(done) {
            // this.$confirm('确认关闭？')
            //   .then((_) => {
            this.dataType = {}
            done()
            //   })
            //   .catch((_) => {})
        },
        handleCloseOrderDrawer(done) {
            // this.$confirm('确认关闭？')
            //   .then((_) => {
            this.dataTypeOrder = {}
            done()
            //   })
            //   .catch((_) => {})
        },
        handleCloseUserDemandsDrawer(done) {
            // this.$confirm('确认关闭？')
            //   .then((_) => {
            this.dataTypeUserDemands = {}
            done()
            //   })
            //   .catch((_) => {})
        },
        openDrawer(key, field) {
            if (this.fieldTabDate === '1') {
                this.user_title = '注册'
                this.openUserDrawer(key, field)
            } else if (this.fieldTabDate === '2') {
                this.user_title = '下单支付成功'
                this.openOrderDrawer(key, field)
            } else if (this.fieldTabDate === '3') {
                this.user_title = '下单未支付'
                this.openOrderDrawer(key, field)
            }
        },
        openUserDrawer(key, field) {
            // this.user_title = title
            this.dataType = {
                miniProTab: this.miniProTab ? this.miniProTab : 'qyh_public',
                // from: this.needFrom ? this.needFrom : 4,
                date_type: this.tabData,
                order_type: this.fieldTabDate ? this.fieldTabDate : '1',
                miniPro: key,
                field,
            }
            this.userDrawer = true
        },
        openOrderDrawer(key, field) {
            // this.order_title = title
            this.dataTypeOrder = {
                miniProTab: this.miniProTab ? this.miniProTab : 'qyh_public',
                // from: this.needFrom ? this.needFrom : 4,
                date_type: this.tabData,
                order_type: this.fieldTabDate ? this.fieldTabDate : '1',
                miniPro: key,
                field
            }
            this.orderDrawer = true
        },
        openUserDemandsDrawer(key, field) {
            // this.user_title = title
            this.dataTypeUserDemands = {
                miniProTab: this.miniProTab ? this.miniProTab : 'qyh_public',
                // from: this.needFrom ? this.needFrom : 4,
                date_type: this.tabData,
                order_type: this.fieldTabDate ? this.fieldTabDate : '1',
                miniPro: key,
                field
            }
            this.userDemandsDrawer = true
        }
    },
    watch: {
        miniProTab() {
            this.loadData()
        },
        tabData: {
            handler(n, o) {
                if (JSON.stringify(n) !== JSON.stringify(o)) {
                    this.loadData()
                }
            },
            // deep: true
        },
        fieldTabDate() {
            this.loadData()
        },
    },
    mounted() {
        this.handleChoose('today')
        this.loadData()
    }
}
</script>

<style scoped>
.public-index {
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

/* 表格 */
.public-index .centered {
    /* 水平居中 */
    text-align: center;
    /* 垂直居中 */
    vertical-align: middle;
}

.public-index .field-table td {
    padding: 0.2rem 0.3rem;
}

.public-index .centered-count {
    text-align: right;
    font-size: medium;
}

/* 表格end */
.public-index .mini-pro-type {
    font-weight: bold;
    font-size: larger;
}

.public-index .ccrmp {
    color: #E6A23C;
}

.public-index .qyh {
    color: #F56C6C;
}

.public-index .public {
    color: #409EFF;
}
</style>


// WEBPACK FOOTER //
// src/pages/PromotionStatistics/Public/PublicIndex.vue